<template>
  <basic-list
    :show-index-col="false"
    :fields="fields"
    select-type="singleMult"
    :loading="state.loading"
    :total="state.total"
    :list="state.list"
    :table-h="tableH"
    :showActionCol="false"
    :showSelectCol="true"
    :page-index="state.pageIndex"
    :page-size="state.pageSize"
    :page-index-change="pageIndexChange"
    :selection-change="selectionChange"
    :page-size-change="pageSizeChange"
    :show-ext-set="buttonData('cdjskz').has"
    :ext-dlg-vis="updateExtDlgVis"
  >
    <template slot="hd-col--l">
      <el-button
        type="primary"
        :size="btnSize"
        @click="proxyActions({ action: 'onAdd', rows: selRows })"
        v-if="buttonData('tjcdjs').has"
        >{{ buttonData("tjcdjs").name }}</el-button
      >
      <el-button
        type="primary"
        :size="btnSize"
        @click="proxyActions({ action: 'distribute', rows: selRows })"
        v-if="buttonData('cdjefpcdjs').has"
        >{{ buttonData("cdjefpcdjs").name }}</el-button
      >
      <!-- <el-button type="primary" :size="btnSize" @click="proxyActions({ action: 'copyUser', rows: selRows })">{{'复制菜单角色'}}</el-button> -->
      <el-button
        :size="btnSize"
        @click="proxyActions({ action: 'edit', rows: selRows })"
        v-if="buttonData('bjcdjs').has"
        >{{ buttonData("bjcdjs").name }}</el-button
      >
      <el-button
        :size="btnSize"
        @click="proxyActions({ action: 'view', rows: selRows })"
        v-if="buttonData('cdjsxq').has"
        >{{ buttonData("cdjsxq").name }}</el-button
      >
      <el-button
        type="danger"
        :size="btnSize"
        @click="proxyActions({ action: 'delet', rows: selRows })"
        v-if="buttonData('sccdjs').has"
        >{{ buttonData("sccdjs").name }}</el-button
      >
      <!-- 启用 -->
      <el-button
        v-if="buttonData('qycdjs').has && isDisable"
        :size="btnSize"
        @click="handleEnableOrDisable"
        >{{ buttonData("qycdjs").name }}</el-button
      >
      <!-- 停用 -->
      <el-button
        v-if="buttonData('tycdjs').has && isEnable"
        :size="btnSize"
        @click="handleEnableOrDisable"
        >{{ buttonData("tycdjs").name }}</el-button
      >
      <!-- 导入菜单角色 -->
      <el-button
        v-if="buttonData('CDJSDR').has && showExportButton"
        :size="btnSize"
        @click="importRole(buttonData('CDJSDR').name)"
        >{{ buttonData("CDJSDR").name }}</el-button
      >
      <!-- 导入角色资源 -->
      <el-button
        v-if="buttonData('DRCDJSZY').has && showExportButton"
        :size="btnSize"
        @click="importRoleResource(buttonData('DRCDJSZY').name)"
        >{{ buttonData("DRCDJSZY").name }}</el-button
      >
      <!-- 导出 -->
      <!-- <el-dropdown
        split-button
        v-if="showExportButton"
        type="primary"
        :size="btnSize"
        @command="exportMenuRole"
        trigger="click"
      >
        {{$t('language.5o6veotsluc0')}}
        <el-dropdown-menu slot="dropdown">
          导入用户
          <el-dropdown-item
            v-if="buttonData('DCCDJS').has"
            divided
            :command="[0, $t('language.5o6veotsmas0')]"
            >{{ buttonData("DCCDJS").name }}</el-dropdown-item
          >
          <el-dropdown-item
            v-if="buttonData('DCYHCDJS').has"
            divided
            :command="[1, $t('language.5o6veotsmeo0')]"
            >{{ buttonData("DCYHCDJS").name }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown> -->
    </template>
  </basic-list>
</template>

<script>
import ExactList from "@/mixins/exactList";
// import { mapState } from "vuex";
export default {
  // computed: {
  //   ...mapState("app", ["showExportButton", "tenementCode", "userName"]),
  // },

  mixins: [ExactList],
  props: {
    proxyActions: Function,
    exportMenuRole: Function,
    importRole: Function,
    importRoleResource: Function,
  },

  mounted() {
    console.log(this.showButtonList, this.tenementCode, "asdwasd");
  },
  data() {
    return {
      fields: [
        { key: "roleName", name: this.$t('language.5o6veotsmhk0') },
        { key: "roleCode", name: this.$t('language.5o6veotsmk40') },
        {
          key: "isDisable",
          name: this.$t('language.5o6u3frcncs0'),
          render: (h, { row }) => {
            const status = { 0: this.$t('language.5o6trh9vmow0'), 1: this.$t('language.5o6trh9vmrs0') };
            const value = status[row.isDisable];
            return <span>{value}</span>;
          },
        },
        {
          key: "sensitiveMark",
          name: this.$t('language.5o6uj7uyt780'),
          render: (h, { row }) => {
            const status = { 0: this.$t('language.5o6uj7uyta00'), 1: this.$t('language.5o6uj7uytcs0') };
            const value = status[row.sensitiveMark];
            return <span>{value}</span>;
          },
        },
        { key: "ext1", name: "", hidden: true },
        { key: "ext2", name: "", hidden: true },
        { key: "ext3", name: "", hidden: true },
        { key: "ext4", name: "", hidden: true },
        { key: "ext5", name: "", hidden: true },
        { key: "ext6", name: "", hidden: true },
        { key: "ext7", name: "", hidden: true },
        { key: "ext8", name: "", hidden: true },
        { key: "ext9", name: "", hidden: true },
        { key: "ext10", name: "", hidden: true },
        { key: "createUser", name: this.$t('language.5o6trh9vn2w0') },
        { key: "createTime", name: this.$t('language.5o6otz4p1t00'), width: 200 },
        { key: "rootOrgName", name: this.$t('language.5o6uj7uytl10') },
        { key: "roleSource", name: this.$t('language.5o6otz4p1ps0') },
        { key: "remark", name: this.$t('language.5o6otz4p1w00') },
      ],
      btnSize: "mini",
    };
  },
  computed: {
    isEnable() {
      return this.selRows.length !== 0 && this.selRows[0].isDisable === 0 ? true : false;
    },
    isDisable() {
      return this.selRows.length !== 0 && this.selRows[0].isDisable === 1 ? true : false;
    },
  },
  methods: {
    // 禁用/启用菜单角色
    handleEnableOrDisable() {
      if (this.selRows.length === 0) return;
      // 0表示启用状态 1表示禁用状态
      const { isDisable, tenementCode, id } = this.selRows[0];
      const params = { data: { tenementCode, id } };
      if (isDisable === 0) {
        this.handleDisableResourceRole(params);
      } else if (isDisable === 1) {
        this.handleEnableResourceRole(params);
      }
    },
    // 禁用
    async handleDisableResourceRole(params) {
      const { code, msg } = await api.rolePermissions.disableResourceRole(params);
      if (code === 200) {
        this.$message.success(msg);
        this.$emit("UPDATE_LIST");
      } else {
        this.$message.error(msg);
      }
    },
    // 启用
    async handleEnableResourceRole(params) {
      const { code, msg } = await api.rolePermissions.enableResourceRole(params);
      if (code === 200) {
        this.$message.success(msg);
        this.$emit("UPDATE_LIST");
      } else {
        this.$message.error(msg);
      }
    },
    updateExtDlgVis() {
      this.$parent.showDialog(this.$t('language.5o6u3frcno10'), "extRoleWinShow");
    },
  },
};
</script>
